// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".panorama-view[data-v-efabdcc4]{width:100%;height:100%;box-sizing:border-box;position:relative}.panorama-view .title[data-v-efabdcc4]{height:30px}.panorama-view .extra[data-v-efabdcc4]{position:absolute;right:30px;top:20px}.panorama-view .map-warp[data-v-efabdcc4]{height:calc(100% - 40px);position:relative}.panorama-view .map-warp .map_tool[data-v-efabdcc4]{position:absolute;top:10px;left:10px}", ""]);
// Exports
module.exports = exports;
